module.exports = __webpack_public_path__ + "img/orange_010.47f63d7a.png";